import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import * as OrganizationActions from './organization.actions';

import { catchError, map, switchMap } from 'rxjs/operators';

import { of } from 'rxjs';

import { OrganizationService } from 'services/organization.service';
import { OrganizationInterfaceWithId } from '@sk/sk-interfaces';


import { environment } from 'environments/environment';



@Injectable()
export class OrganizationEffects {


  getOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.getFireStoreOrganization),
      switchMap(payload => this.organizationService.getFireStoreOrganization(payload.organizationId)),
      map((org: OrganizationInterfaceWithId) => {
        return OrganizationActions.fromFireStoreAddOrganization({ organization: org });
      }),
      catchError((error) => {
        if (!environment.production) {
          console.error('Firestore Organization Error: ', error.message);
        }
        return of(OrganizationActions.getFireStoreOrganizationError({
          error
        }));
      })
    )
  );


 updateOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.updateOrganization),
      switchMap(payload => this.organizationService.updateOrganizationFromNgrx(payload.changes)),
      map(() => {
        return OrganizationActions.updateOrganizationSuccess({ });
      }),
      catchError((error) => {
        if (!environment.production) {
          console.error('Firestore Organization Update Error: ', error.message);
        }
        return of(OrganizationActions.updateOrganizationError({
          error
        }));
      })
    )
  );


  constructor(private actions$: Actions,
              private organizationService: OrganizationService) {
  }
}
